export default __webpack_public_path__ + "5e74807.png";